import {type RestTypeWithTypename} from '../rest-type-with-typename';
import {type DownloadBookingsOrgQuery} from './download-bookings-org-request';

export function downloadBookingsOrgTypePatcher(
    data: DownloadBookingsOrgQuery,
): RestTypeWithTypename<DownloadBookingsOrgQuery> {
    return {
        __typename: 'DownloadBookingsQuery',
        ...data,
        occupancyBookings: {
            __typename: 'DownloadBookingsQueryUrl',
            ...data.occupancyBookings,
        },
    };
}
